import React, { Fragment, useState } from 'react';
import { navigate } from 'gatsby';

import {
  AppBar,
  Container,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText, makeStyles,
  Toolbar,
  Typography,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import Phone from '@material-ui/icons/Phone';
import Drawer from '@material-ui/core/Drawer';
import styled from '@emotion/styled';

import logo from '../../images/logo.png';
import { navigationItemsMobile } from '../../consts/navigationItems';

import theme from '../../common/theme';
import LogoAnchor from '../atoms/LogoAnchor';

const useStyles = makeStyles((theme) => ({
  offset: theme.mixins.toolbar,
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

const MobileNavigationHeader = () => {
  const classes = useStyles(theme);
  // const { push } = history
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown'
      && (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setIsOpen(open);
  };

  const renderSideList = () => (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {navigationItemsMobile.map((item) => (
          <Fragment key={item.label}>
            <ListItem
              button
              key={item.label}
              onClick={() => {
                if (item.isOuter) {
                  // if (item.target === '_blank') {
                  //   window.open(item.path, item.target);
                  // }
                  if (typeof window !== 'undefined' && item.target === '_blank') {
                    window.open(item.path, item.target);
                  }
                } else {
                  navigate(item.path);
                  // push(item.path)
                }
              }}
            >
              <ListItemText primary={item.label} />
            </ListItem>
            <Divider />
          </Fragment>
        ))}
      </List>
    </div>
  );

  return (
    <>
      <div className={classes.root}>
        <AppBar position="fixed">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title} />
            <IconButton
              aria-label="tel"
              color="inherit"
              edge="end"
              onClick={() => {
                if (typeof window !== 'undefined') window.open(`tel:${process.env.REACT_APP_HP.replace(/-/g, '')}`);
              }}
            >
              <Phone />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className={classes.offset} />
      </div>
      <Container
        style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}
      >
        <LogoAnchor href="/" target="_self">
          <img src={logo} alt="미래줄눈" style={{ height: 50 }} />

          {process.env.REACT_APP_MOBILE_LOGO_CAPTION_YN === 'Y' && (
            <>
              <br />
              <span
                style={{ letterSpacing: 2, color: '#686565', fontWeight: 900 }}
              >
                {process.env.REACT_APP_LOGO_TITLE}
              </span>
            </>
          )}
        </LogoAnchor>
      </Container>
      <Drawer open={isOpen} onClose={toggleDrawer(false)}>
        {renderSideList()}
      </Drawer>
    </>
  );
};
export default MobileNavigationHeader;
